<form [formGroup]="form.formGroup">
  <div class="flex flex-col space-y-2">

    <div class="flex flex-col">
      <label for="pipeRoughness">Pipe Roughness</label>
      <app-validated-number-input
        [id]="'pipeRoughness'"
        [control]="control('pipeRoughness')"
        [value]="control('pipeRoughness').value"
        [validation]="pipeRoughnessValidation"
        [unit]="userUnits.shortLengths"
        [unitPrecisionOverrides]="{ 'in': 6, 'cm': 5, 'mm':4 }"
      ></app-validated-number-input>
    </div>

    <div class="flex flex-col">
      <div class="field">
        <label for="multiphaseCorrelation">Multiphase Flow Correlation</label>
        <span class="pl-1">
          <i [pTooltip]="multiphaseCorrelationTooltip" class="pi pi-info-circle cursor-help"></i>
        </span>
      </div>
      <p-select [disabled]="isReadOnly" [options]="multiphaseCorrelations"
        [formControlName]="form.formControlNames.multiphaseCorrelation" optionLabel="name" optionValue="value"
        appendTo="body"></p-select>
      </div>

    @if (!(gasHidden || gasModelHidden)) {
      <div class="flex flex-col">
        <label for="gasModel">Gas Model</label>
        <p-select [disabled]="isReadOnly" [options]="gasModels" [formControlName]="form.formControlNames.gasModel"
          optionLabel="name" optionValue="value" appendTo="body"></p-select>
      </div>
    }

    @if (co2FluidSelected) {
      <div class="flex flex-col">
        <label for="co2EosOption">CO2 EOS</label>
        <p-select [disabled]="isReadOnly" [options]="co2EosOptions" [formControlName]="form.formControlNames.co2EosOption"
          optionLabel="name" optionValue="value" appendTo="body"></p-select>
      </div>
    }

    @if (!gasHidden && !co2FluidSelected) {
      <div class="flex flex-col">
        <label>GOR</label>
        <p-inputgroup>
          <p-select [disabled]="isReadOnly || !oilGas[1]" [options]="gorOptions" optionLabel="label"
            optionValue="value" appendTo="body" (onChange)="onGorTypeChange($event)" [formControlName]="form.formControlNames.gasToOilRatio"></p-select>
          <p-inputNumber 
            #gorInput
            [minFractionDigits]="1" 
            [placeholder]="gor" 
            (onBlur)="updateGor('gor')" 
            [disabled]="gorEnabled"/>
          <p-inputgroup-addon>{{ gorUnit }}</p-inputgroup-addon>
        </p-inputgroup>
      </div>
    }

    @if (!(oilHidden || co2FluidSelected)) {
      <div class="flex flex-col">
        <label for="oilFlowRate">Oil Flow Rate</label>
        <app-validated-number-input
          [id]="'oilFlowRate'"
          [control]="control('oilFlowRate')"
          [value]="control('oilFlowRate').value"
          [validation]="oilFlowRateValidation"
          (onChange)="updateGor('oil')"
          [unit]="flowUnit"
        ></app-validated-number-input>
      </div>
      }

      @if (!gasHidden) {
        <div class="flex flex-col">
          <label for="gasFlowRate">Gas Flow Rate</label>
          @if (!includeRestartOperation) {
            <app-validated-number-input
              [id]="'gasFlowRate'"
              [control]="control('gasFlowRate')"
              [value]="control('gasFlowRate').value"
              [validation]="gasFlowRateValidation"
              (onChange)="updateGor('gas')"
              [unitPrecisionOverrides]="{ 'MMm³/d': 6, 'MMscf/day': 2, 'scf/day': 2, 'm³/d': 2 }"
              [unit]="gasFlowUnit"
            ></app-validated-number-input>
          } @else {
            <input type="number" pInputText class="w-full" placeholder="Restart Operation Enabled" [disabled]="true" />
          }
        </div>
      }

    @if (!co2FluidSelected) {
      <div class="flex flex-col">
        <label for="waterFlowRate">Water Flow Rate</label>
        <app-validated-number-input
          [id]="'waterFlowRate'"
          [control]="control('waterFlowRate')"
          [value]="control('waterFlowRate').value"
          [validation]="waterFlowRateValidation"
          (onChange)="updateGor('water')"
          [unit]="flowUnit"
        ></app-validated-number-input>
      </div>
    }
  </div>
</form>